// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"GQ-z","hovered":"HQ-z","hoverImage":"IQ-z","mainImage":"JQ-z","imageNoBackground":"KQ-z","fullSizeImage":"LQ-z"};